
import React, { Fragment } from 'react'

import routes from 'routes/public/packages'


export default () =>
  <Fragment>
    { routes }
  </Fragment>
